// api/referrerReport.js 或 services/referrerReport.js
import axios from '@/libs/api.request'

// 获取推荐人报表
export function getReferrerReport(data) {
  return axios.request({
    url: '/referrerReport/list',
    method: 'post',
    data
  })
}